var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.605362 7.69574H5.28316V23.9985H0.605362V7.69574ZM2.82502 5.65655H2.79116C1.09784 5.65655 0 4.4103 0 2.83212C0 1.22167 1.13029 0 2.85748 0C4.58325 0 5.6444 1.21859 5.67827 2.82751C5.67827 4.40569 4.58325 5.65655 2.82502 5.65655ZM24 24H18.6957V15.562C18.6957 13.3538 17.8659 11.8479 16.0414 11.8479C14.6458 11.8479 13.8697 12.8636 13.5085 13.8456C13.373 14.1959 13.3942 14.6861 13.3942 15.1779V24H8.13923C8.13923 24 8.20696 9.05417 8.13923 7.69574H13.3942V10.2543C13.7046 9.13561 15.3838 7.53899 18.0635 7.53899C21.3881 7.53899 24 9.88552 24 14.9335V24Z",
    fill: "#13294B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.ffbe9ec66ec3680682bc827f7bc00f1f.svg";
export { ForwardRef as ReactComponent };